import PersonIcon from '@mui/icons-material/Person';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {User} from '@cp/model';

export interface AccountInfoEmailProps {
  user: User;
}

export default function AccountInfoEmail({user}: AccountInfoEmailProps) {
  return (
    <Box sx={{display: 'flex', alignItems: 'center', gap: 2, mb: 2}}>
      <PersonIcon color="primary" />
      <Box>
        <Typography variant="body1">{user.name || user.email}</Typography>
        <Typography variant="body2" color="text.secondary">
          {user.email}
        </Typography>
      </Box>
    </Box>
  );
}
